<div (click)="rate()">
  <img class="favorite-icon" src="/assets/icons/icons8-star-filled.svg" />
  <img class="favorite-icon" src="/assets/icons/icons8-star-filled.svg" />
  <img class="favorite-icon" src="/assets/icons/icons8-star-filled.svg" />
  <img class="favorite-icon" src="/assets/icons/icons8-star.svg" />
  <img class="favorite-icon" src="/assets/icons/icons8-star.svg" />
</div>
